export default __webpack_public_path__ + "static/media/Group 5172.12dc0dd0.svg";